module.exports = __webpack_public_path__ + "img/BonofBlood.bc34cbdb.png";